import {
    getBranchId,
    getRegisterAuthToken,
    getTokenVariable,
    setBranchId,
    setRegisterAuthToken,
    useRegisterConfiguration,
} from '@register-ui/utils';
import { useLayoutEffect } from 'react';

export function MigrateAuthToken() {
    const { config } = useRegisterConfiguration();

    // TODO: Delete backward compat logic after branch switching is fully rolled out and stable
    useLayoutEffect(() => {
        const hasRegisterAuthToken = getRegisterAuthToken();
        const sessionToken = getTokenVariable();
        const branchId = getBranchId();

        if (sessionToken && !hasRegisterAuthToken) {
            setRegisterAuthToken(sessionToken);

            if (!branchId && config.branchId) {
                setBranchId(config.branchId);
            }
        }
    }, []);

    return null;
}
